import {httpService} from '../../common/ajax/index';
export default {
  getList: httpService('/fuwu/ajax/customTask/pageQueryCustomizedTask.htm', {
      method: 'post'
  }),
  accountType: httpService('/fuwu/ajax/customTask/checkAccountIsBusi.action', {
    method: 'get'
  }),
  publishTask: httpService('/fuwu/ajax/customTask/publishCustomized.action', {
    method: 'post'
  }),
  getProviderList: httpService('/fuwu/ajax/customTask/queryProviderList.action', {
    method: 'get'
  }),
  getTaskDetail: httpService('/fuwu/ajax/customTask/queryCustomizedTaskDetail.action', {
    method: 'post'
  }),
  cancelRequire: httpService('/fuwu/ajax/customTask/cancelCustomized.action', {
    method: 'post'
  }),
  selectProvider: httpService('/fuwu/ajax/customTask/confirmProviderCustomized.action', {
    method: 'post'
  }),
  // 重新发布
  republish: httpService('/fuwu/ajax/customTask/republishCustomized.action', {
    method: 'post'
  }),
  // 获取评分人员信息
  getScoreRole: httpService('/fuwu/ajax/customTask/queryTaskSignatureRoles.action', {
    method: 'get'
  }),
  // 发起评分
  operateTaskSignature: httpService('/fuwu/ajax/customTask/operateTaskSignature.action', {
    method: 'post'
  }),
  // 报名
  signUp: httpService('/fuwu/ajax/customTask/taskSignUp.action', {
    method: 'post'
  }),
  // 服务商取消报名
  cancelSign: httpService('/fuwu/ajax/customTask/cancelTaskSignUp.action', {
    method: 'get'
  }),
  getScroeDetail: httpService('/fuwu/ajax/customTask/queryTaskSignatureList.action', {
    method: 'post'
  }),
};